export type AnimeType = "TV" | "剧场版" | "OVA";

export interface Anime {
  id: string;
  title: string;
  original: string;
  year: number;
  type: AnimeType;
  tags: string[];
  rating: number;
  episodes: number;
  status: string;
  studio: string;
  description: string;
  image: string;
}

export const animeList: Anime[] = [
  {
    id: "frieren",
    title: "葬送的芙莉莲",
    original: "葬送のフリーレン",
    year: 2023,
    type: "TV",
    tags: ["奇幻", "治愈", "冒险"],
    rating: 9.8,
    episodes: 28,
    status: "已完结",
    studio: "MADHOUSE",
    description: "勇者一行打倒魔王后，寿命漫长的精灵魔法使芙莉莲踏上与逝去同伴重逢的旅途，在旅途中重新理解人类、友情与时间的意义。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20gentle%20elf%20mage%20with%20long%20white%20hair%20walking%20through%20a%20golden%20autumn%20forest%2C%20soft%20warm%20light%20rays%20through%20trees%2C%20poignant%20peaceful%20mood%2C%20watercolor%20style%2C%20detailed%20painting%2C%20cinematic%20composition&width=600&height=840&seq=milk-frieren&orientation=portrait",
  },
  {
    id: "kimetsu",
    title: "鬼灭之刃 柱训练篇",
    original: "鬼滅の刃 柱稽古編",
    year: 2024,
    type: "TV",
    tags: ["热血", "冒险", "神作"],
    rating: 9.5,
    episodes: 8,
    status: "已完结",
    studio: "ufotable",
    description: "炭治郎与柱们为迎战鬼舞辻无惨而展开严苛的柱合训练，众人各怀觉悟奔赴最终决战的前奏。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20determined%20young%20samurai%20holding%20a%20katana%20with%20flame%20effects%20in%20the%20background%2C%20japanese%20water%20waves%20pattern%2C%20dynamic%20action%20pose%2C%20rich%20red%20and%20deep%20teal%20palette%2C%20high%20detail%20painting&width=600&height=840&seq=milk-kimetsu&orientation=portrait",
  },
  {
    id: "jujutsu",
    title: "咒术回战 怀玉·玉折",
    original: "呪術廻戦 懐玉・玉折",
    year: 2023,
    type: "TV",
    tags: ["热血", "奇幻", "悬疑"],
    rating: 9.3,
    episodes: 5,
    status: "已完结",
    studio: "MAPPA",
    description: "五条悟与夏油杰的少年时代在夜幕下展开，一段关于最强与挚友的宿命往事，逐渐走向不可挽回的转折。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20two%20young%20sorcerers%20under%20a%20night%20sky%20with%20purple%20cursed%20energy%20glow%2C%20urban%20japan%20background%2C%20moody%20dramatic%20lighting%2C%20bold%20brush%20style%2C%20high%20detail%20anime%20artwork&width=600&height=840&seq=milk-jujutsu&orientation=portrait",
  },
  {
    id: "spyfamily",
    title: "间谍过家家 第二季",
    original: "SPY×FAMILY Season 2",
    year: 2023,
    type: "TV",
    tags: ["搞笑", "日常", "治愈"],
    rating: 9.1,
    episodes: 12,
    status: "已完结",
    studio: "WIT STUDIO",
    description: "间谍、杀手与读心少女组成的临时家庭，在欢笑与误会中努力扮演「完美的一家」，守护彼此的平静日常。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20cheerful%20family%20of%20three%20with%20a%20little%20girl%20with%20pink%20hair%20in%20the%20center%2C%20bright%20playful%20composition%2C%20warm%20sunny%20palette%2C%20clean%20modern%20anime%20style%2C%20charming%20and%20lively&width=600&height=840&seq=milk-spyfamily&orientation=portrait",
  },
  {
    id: "oshi",
    title: "我推的孩子",
    original: "【推しの子】",
    year: 2023,
    type: "TV",
    tags: ["悬疑", "偶像", "神作"],
    rating: 9.4,
    episodes: 11,
    status: "已完结",
    studio: "动画工房",
    description: "产科医生与偶像粉丝转生为偶像的孩子，踏入光鲜与暗流交织的娱乐圈，追寻母亲之死的真相。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20silver%20haired%20boy%20with%20bright%20star%20eyes%20standing%20before%20a%20glowing%20spotlight%20stage%2C%20dark%20backstage%20mood%2C%20cinematic%20contrast%20lighting%2C%20dramatic%20anime%20artwork%2C%20high%20detail&width=600&height=840&seq=milk-oshi&orientation=portrait",
  },
  {
    id: "kusuriya",
    title: "药屋少女的呢喃",
    original: "薬屋のひとりごと",
    year: 2023,
    type: "TV",
    tags: ["古风", "悬疑", "推理"],
    rating: 9.6,
    episodes: 24,
    status: "已完结",
    studio: "TOHO animation STUDIO",
    description: "身处后宫的药屋少女猫猫，凭敏锐洞察与药学知识破解宫中奇案，在明争暗斗的宫廷中周旋求生。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20girl%20in%20ancient%20chinese%20court%20attire%20holding%20herbs%2C%20elegant%20imperial%20palace%20background%2C%20soft%20warm%20lotus%20and%20moonlight%2C%20refined%20traditional%20painting%20style&width=600&height=840&seq=milk-kusuriya&orientation=portrait",
  },
  {
    id: "dungeon",
    title: "迷宫饭",
    original: "ダンジョン飯",
    year: 2024,
    type: "TV",
    tags: ["美食", "奇幻", "搞笑"],
    rating: 9.0,
    episodes: 24,
    status: "已完结",
    studio: "TRIGGER",
    description: "在迷宫中「吃魔物」的冒险者们，用一场场奇思妙想的美食之旅，把求生变成最认真的料理现场。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20an%20adventurer%20party%20cooking%20a%20giant%20monster%20in%20an%20underground%20dungeon%20kitchen%2C%20steam%20and%20warm%20firelight%2C%20whimsical%20fun%20mood%2C%20colorful%20stylish%20anime%20artwork&width=600&height=840&seq=milk-dungeon&orientation=portrait",
  },
  {
    id: "haikyu",
    title: "排球少年!! 垃圾场决战",
    original: "ハイキュー!! ゴミ捨て場の決戦",
    year: 2024,
    type: "剧场版",
    tags: ["运动", "热血", "青春"],
    rating: 9.5,
    episodes: 1,
    status: "已上映",
    studio: "Production I.G",
    description: "乌野与音驹这对宿敌，在垃圾场体育馆迎来「一战定生死」的巅峰对决，青春的呐喊在最后一声哨响前沸腾。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20two%20volleyball%20teams%20in%20an%20intense%20match%20inside%20a%20gymnasium%2C%20ball%20midair%20with%20dramatic%20spike%2C%20dynamic%20motion%20lines%2C%20energetic%20sports%20composition%2C%20vivid%20orange%20and%20teal%20palette&width=600&height=840&seq=milk-haikyu&orientation=portrait",
  },
  {
    id: "eva",
    title: "新世纪福音战士：终",
    original: "シン・エヴァンゲリオン劇場版",
    year: 2021,
    type: "剧场版",
    tags: ["科幻", "神作", "催泪"],
    rating: 9.2,
    episodes: 1,
    status: "已上映",
    studio: "Khara",
    description: "在崩坏的世界尽头，碇真嗣与同伴们迎来最后的抉择，一段关于成长、告别与和解的宏大致密终点。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20giant%20mecha%20silhouette%20against%20a%20red%20watery%20horizon%20under%20an%20orange%20sky%2C%20existential%20epic%20mood%2C%20sharp%20cinematic%20lighting%2C%20powerful%20scifi%20anime%20artwork%2C%20high%20contrast&width=600&height=840&seq=milk-eva&orientation=portrait",
  },
  {
    id: "chihiro",
    title: "千与千寻",
    original: "千と千尋の神隠し",
    year: 2001,
    type: "剧场版",
    tags: ["奇幻", "神作", "催泪"],
    rating: 9.7,
    episodes: 1,
    status: "经典",
    studio: "吉卜力工作室",
    description: "少女千寻误入神灵世界，在汤屋打工成长，凭善良与勇气救回变猪的父母，也找回了自己的名字。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20girl%20standing%20before%20a%20traditional%20japanese%20bathhouse%20at%20dusk%2C%20lantern%20lights%20glowing%2C%20spirit%20world%20atmosphere%2C%20whimsical%20studio%20ghibli%20inspired%20painting%2C%20dreamy%20warm%20light&width=600&height=840&seq=milk-chihiro&orientation=portrait",
  },
  {
    id: "yourname",
    title: "你的名字。",
    original: "君の名は。",
    year: 2016,
    type: "剧场版",
    tags: ["恋爱", "奇幻", "催泪"],
    rating: 9.3,
    episodes: 1,
    status: "经典",
    studio: "CoMix Wave Films",
    description: "跨越时空互换身体的少年少女，在彗星坠落之夜彼此追寻，一段关于名字与思念的奇迹故事。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20boy%20and%20girl%20gazing%20at%20each%20other%20across%20a%20comet%20streaking%20night%20sky%2C%20shining%20lake%20reflection%2C%20luminous%20pastel%20blue%20and%20purple%20palette%2C%20romantic%20atmospheric%20anime%20artwork&width=600&height=840&seq=milk-yourname&orientation=portrait",
  },
  {
    id: "violet",
    title: "紫罗兰永恒花园",
    original: "ヴァイオレット・エヴァーガーデン",
    year: 2018,
    type: "TV",
    tags: ["治愈", "催泪", "神作"],
    rating: 9.4,
    episodes: 13,
    status: "已完结",
    studio: "京都动画",
    description: "为寻找「我爱你」含义的自动手记人偶薇尔莉特，在代写书信中见证无数人的悲欢，最终理解什么是爱。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20golden%20haired%20automaton%20girl%20writing%20a%20letter%20by%20a%20sunlit%20window%2C%20flowing%20blue%20ribbon%2C%20ethereal%20soft%20lighting%2C%20gentle%20melancholy%20mood%2C%20refined%20detailed%20anime%20artwork&width=600&height=840&seq=milk-violet&orientation=portrait",
  },
  {
    id: "fma",
    title: "钢之炼金术师 FA",
    original: "鋼の錬金術師 FULLMETAL ALCHEMIST",
    year: 2009,
    type: "TV",
    tags: ["奇幻", "热血", "神作"],
    rating: 9.6,
    episodes: 64,
    status: "经典",
    studio: "BONES",
    description: "为取回失去的身体，爱德华兄弟踏上寻找贤者之石的旅程，在等价交换的法则下直面人性、战争与牺牲。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20alchemist%20with%20a%20metal%20arm%20surrounded%20by%20glowing%20alchemy%20circles%2C%20steampunk%20mechanical%20details%2C%20gold%20and%20crimson%20energy%2C%20epic%20adventure%20mood%2C%20detailed%20anime%20artwork&width=600&height=840&seq=milk-fma&orientation=portrait",
  },
  {
    id: "aot",
    title: "进击的巨人 最终季",
    original: "進撃の巨人 The Final Season",
    year: 2020,
    type: "TV",
    tags: ["热血", "冒险", "悬疑"],
    rating: 9.5,
    episodes: 28,
    status: "已完结",
    studio: "MAPPA",
    description: "墙外世界的真相彻底颠覆了认知，艾伦一行在自由与毁灭的悖论中走向终局，人与巨人的战争迎来最终裁决。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20soldiers%20in%20brown%20uniforms%20using%20omni%20directional%20maneuver%20gear%20above%20colossal%20walls%2C%20titan%20silhouette%20in%20distance%2C%20grim%20stormy%20sky%2C%20epic%20war%20mood%2C%20dark%20detailed%20anime%20artwork&width=600&height=840&seq=milk-aot&orientation=portrait",
  },
  {
    id: "aot-lostgirls",
    title: "进击的巨人 LOST GIRLS",
    original: "進撃の巨人 LOST GIRLS",
    year: 2017,
    type: "OVA",
    tags: ["悬疑", "冒险"],
    rating: 9.0,
    episodes: 3,
    status: "已完结",
    studio: "WIT STUDIO",
    description: "聚焦阿尼与三笠视角的番外故事，补全正传中未展开的细节与人物心路，是巨人家族粉丝的必看支线。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20two%20young%20female%20soldiers%20in%20brown%20survey%20corps%20uniforms%20standing%20in%20a%20moody%20forest%2C%20swords%20drawn%2C%20tense%20suspenseful%20atmosphere%2C%20muted%20warm%20tones%2C%20detailed%20anime%20artwork&width=600&height=840&seq=milk-aotlost&orientation=portrait",
  },
  {
    id: "steins",
    title: "命运石之门",
    original: "STEINS;GATE",
    year: 2011,
    type: "TV",
    tags: ["科幻", "悬疑", "神作"],
    rating: 9.2,
    episodes: 24,
    status: "经典",
    studio: "WHITE FOX",
    description: "中二科学家冈部伦太郎用微波炉意外发明了时间机器，在无数次世界线跳跃中寻找拯救同伴的答案。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20mad%20scientist%20boy%20in%20a%20lab%20coat%20surrounded%20by%20glowing%20gears%20and%20green%20circuits%2C%20conspiracy%20mood%2C%20dark%20laboratory%20lighting%2C%20intricate%20scifi%20details%2C%20detailed%20anime%20artwork&width=600&height=840&seq=milk-steins&orientation=portrait",
  },
];

export const typeOptions: AnimeType[] = ["TV", "剧场版", "OVA"];

export const tagOptions: string[] = [
  "热血",
  "奇幻",
  "治愈",
  "悬疑",
  "日常",
  "恋爱",
  "科幻",
  "运动",
  "古风",
  "美食",
  "搞笑",
  "冒险",
  "催泪",
  "神作",
  "推理",
  "偶像",
  "青春",
  "经典",
];

export const yearOptions: number[] = Array.from(
  new Set(animeList.map((a) => a.year)),
).sort((a, b) => b - a);